<template>
  <img width="48px" :src="require(`@/assets/gel/images/illustrations/${iconName}.svg`)" :alt="iconName" />
</template>

<script>

export default {
  name: 'Illustration',
  props: {
    iconName: String
  },
}
</script>